import React, { useState, useRef, useEffect } from "react";
import {
  FaChevronUp,
  FaChevronDown,
  FaEllipsisV,
  FaTimes,
  FaCheck,
  FaThumbsUp,
  FaThumbsDown,
} from "react-icons/fa";

function _OrderRow({
  transaction,
  menuOpenId,
  setMenuOpenId,
  isSelected,
  onSelect,
  handleApprove,
  handleDecline,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);
  const [height, setHeight] = useState("0px");

  const [activeTab, setActiveTab] = useState("items");
  const isMenuOpen = menuOpenId === transaction.TransactionID;

  const menuRef = useRef(null);
  const rowRef = useRef(null);

  useEffect(() => {
    if (isOpen && rowRef.current) {
      rowRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [isOpen]);

  const formatToMMDDYYYY = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);

    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yyyy = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert to 12-hour format

    return `${mm}/${dd}/${yyyy} ${hours}:${minutes} ${ampm}`;
  };

  useEffect(() => {
    if (contentRef.current) {
      if (isOpen) {
        setHeight(`${contentRef.current.scrollHeight}px`);
      } else {
        setHeight("0px");
      }
    }
  }, [isOpen, activeTab, transaction.OrderItems]);

  return (
    <>
      <tr>
        <td
          className="td-toggle-icon"
          onClick={() => setIsOpen(!isOpen)}
          style={{ cursor: "pointer" }}
        >
          {isOpen ? (
            <FaChevronUp className="toggle-icon" title="Collapse" />
          ) : (
            <FaChevronDown className="toggle-icon" title="Expand" />
          )}
        </td>

        <td>
          <input
            type="checkbox"
            checked={isSelected}
            onChange={() => onSelect(transaction.TransactionID)} // <-- pass correct ID
            aria-label={`select-transaction-${transaction.TransactionID}`}
          />
        </td>
        <td>{transaction.TransactionNumber}</td>
        <td>{transaction.CustomerName}</td>
        <td>{transaction.OrderItems.length}</td>
        <td>{formatToMMDDYYYY(transaction.DatePurchase)}</td>
        <td>{transaction.PaymentMethod}</td>
        <td>{transaction.PaymentType}</td>
        <td>{transaction.PaymentAmount}</td>
        <td>FOR APPROVAL</td>
        <td className="td-actions">
          <div className="td-action-btns-wrapper" ref={menuRef}>
            <FaThumbsUp
              className="readytoship"
              title="APPROVE"
              style={{ color: "green", cursor: "pointer" }}
              onClick={() => handleApprove(transaction)}
            />
            <FaThumbsDown
              className="cancel"
              title="DECLINE"
              style={{ color: "red", cursor: "pointer" }}
              onClick={() => handleDecline(transaction)}
            />
          </div>
        </td>
      </tr>

      {/* Collapsible Section */}
      <tr ref={rowRef}>
        <td
          className="td-other-order-field"
          colSpan={11}
          style={{ padding: 0, border: 0 }}
        >
          <div
            ref={contentRef}
            style={{
              maxHeight: height,
              overflow: "hidden",
              transition: "max-height 0.4s ease, opacity 0.3s ease",
              opacity: isOpen ? 1 : 0,
            }}
            className="other-collapse-content"
          >
            {/* Toggle with text links */}
            <div
              className="expand-links"
              style={{
                padding: "10px 20px",
                borderBottom: "1px solid #ddd",
                display: "flex",
                gap: "15px",
              }}
            >
              <span
                onClick={() => setActiveTab("items")}
                style={{
                  cursor: "pointer",
                  color: activeTab === "items" ? "#007bff" : "#555",
                  textDecoration: activeTab === "items" ? "underline" : "none",
                  fontWeight: activeTab === "items" ? "600" : "400",
                }}
              >
                View Items
              </span>
              <span
                onClick={() => setActiveTab("receipt")}
                style={{
                  cursor: "pointer",
                  color: activeTab === "receipt" ? "#007bff" : "#555",
                  textDecoration:
                    activeTab === "receipt" ? "underline" : "none",
                  fontWeight: activeTab === "receipt" ? "600" : "400",
                }}
              >
                View Receipt
              </span>
            </div>

            {activeTab === "items" && (
              <>
                {transaction.PaymentType === "full" ? (
                  <>
                    <div className="items-list">
                      <div className="ord-prod-items-header">
                        <div className="ord-blank"></div>
                        <div className="ord-prod-name">Product Name</div>
                        <div className="ord-prod-quantity">Quantity</div>
                        <div className="ord-prod-unitprice">Unit Price</div>
                        <div className="ord-prod-dpunit">
                          Deposited <br />
                          Amount
                        </div>
                        <div className="ord-prod-dptotal">Balance</div>
                      </div>
                    </div>

                    <div className="items-list">
                      {transaction.OrderItems.map((item) => (
                        <div key={item.id} className="ord-prod-items">
                          <img
                            src={`${
                              process.env.REACT_APP_BASE_URL
                            }Assets/Products/${item.PD_ID}/${
                              item.IMG[0] ?? "no-image.png"
                            }`}
                            alt={item.ProductName}
                            className="ord-prod-pic"
                          />
                          <div className="ord-prod-name">
                            {item.ProductName}
                          </div>
                          <div className="ord-prod-quantity">
                            x{item.Quantity}
                          </div>
                          <div className="ord-prod-unitprice">
                            PHP {item.UnitPrice}
                          </div>
                          <div className="ord-prod-dpunit">
                            PHP {item.Deposited}
                          </div>
                          <div className="ord-prod-dptotal">
                            PHP {item.Balance}
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="items-list">
                      <div className="ord-prod-items-header">
                        <div className="ord-blank"></div>
                        <div className="ord-prod-name">Product Name</div>
                        <div className="ord-prod-quantity">Quantity</div>
                        <div className="ord-prod-unitprice">Unit Price</div>
                        <div className="ord-prod-dpunit">
                          Downpayment <br />
                          (Per unit)
                        </div>
                        <div className="ord-prod-dptotal">
                          Downpayment <br />
                          Subtotal
                        </div>
                      </div>
                    </div>

                    <div className="items-list">
                      {transaction.OrderItems.map((item) => (
                        <div key={item.id} className="ord-prod-items">
                          <img
                            src={`${
                              process.env.REACT_APP_BASE_URL
                            }Assets/Products/${item.PD_ID}/${
                              item.IMG[0] ?? "no-image.png"
                            }`}
                            alt={item.ProductName}
                            className="ord-prod-pic"
                          />
                          <div className="ord-prod-name">
                            {item.ProductName}
                          </div>
                          <div className="ord-prod-quantity">
                            x{item.Quantity}
                          </div>
                          <div className="ord-prod-unitprice">
                            PHP {item.UnitPrice}
                          </div>
                          <div className="ord-prod-dpunit">
                            PHP {item.Downpayment}
                          </div>
                          <div className="ord-prod-dptotal">
                            PHP {item.Downpayment * item.Quantity}
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </>
            )}

            {activeTab === "receipt" && (
              <div className="receipt-view">
                <img
                  src={`${
                    process.env.REACT_APP_BASE_URL
                  }Assets/purchase_order/${transaction.TransactionID}/${
                    transaction.Receipt ?? "no-image.png"
                  }`}
                  alt="Receipt"
                  className="receipt-img"
                  onLoad={() => {
                    if (contentRef.current) {
                      setHeight(`${contentRef.current.scrollHeight}px`);
                    }
                  }}
                />
              </div>
            )}
          </div>
        </td>
      </tr>
    </>
  );
}

export default _OrderRow;
